<template>
<div class="content" @click="$store.dispatch('form/FORM_PREVIOUSLAYOUT')">
  <i class="fas fa-chevron-left fa-3x" style="color: white"></i>
</div>
</template>

<script>
export default {
  name: 'back-button'
};
</script>

<style scoped>
.content {
  height: 100%;
  background-color: rgba(63, 63, 63, 0.5);
  cursor: pointer;
}.content > i {
   position:relative;
   top: calc(50% - 10px);
}
</style>



// WEBPACK FOOTER //
// src/components/BackButton.vue